{
  "search": "Buscar",
  "searchWithin": "Buscar en"
}
